import booksRouter from './books/index.route';
import eBooksRouter from './eBooks/index.route';

export default [{
  path: 'quanzi',
  name: 'quanzi',
  component: () => import('./quanzi')
}, {
  path: 'kol-user',
  name: 'kol-user',
  component: () => import('./kol-manage/user'),
  meta: {
    code: '/basic/kol.htm'
  }
}, {
  path: 'kol-problem',
  name: 'kol-problem',
  component: () => import('./kol-manage/problem'),
  meta: {
    code: '/basic/question.htm'
  }
}, {
  path: 'kol-problem-package',
  name: 'kol-problem-package',
  component: () => import('./kol-manage/problem/package'),
  meta: {
    // code: '/basic/question.htm'
  }
}, {
  path: 'kol-article',
  name: 'kol-article',
  component: () => import('./kol-manage/article'),
  meta: {
    code: '/basic/document.htm'
  }
}, {
  path: 'kol-video',
  name: 'kol-video',
  component: () => import('./kol-manage/video'),
  meta: {
    code: '/basic/video.htm'
  }
}, {
  path: 'kol-invit-code',
  name: 'kol-invite',
  component: () => import('./kol-manage/invite-code'),
  meta: {
    code: '/award/kolCode.htm'
  }
}, {
  path: 'gift-code-upload',
  name: 'gify-code-upload',
  component: () => import('./gift-upload/index.vue'),
  meta: {
    code: '/award/code.htm'
  }
}, {
  path: 'gift-ziliao',
  name: 'gift-ziliao',
  component: () => import('./new-user/gift-ziliao/index.vue'),
  meta: {
    code: '/award/document.htm'
  }
}, {
  path: 'new-gift',
  name: 'new-gift',
  component: () => import('./new-user/gift/index.vue'),
  meta: {
    code: '/award/package.htm'
  }
}, {
  path: 'college-index',
  name: 'college-index',
  component: () => import('./college/index/index.vue'),
  meta: {
    code: '/college/home.htm'
  }
}, {
  path: 'college-course',
  name: 'college-course',
  component: () => import('./college/course/index.vue'),
  meta: {
    code: '/college/collegeCourseInfo.htm'
  }
}, {
  path: 'college-class-hour',
  name: 'college-class-hour',
  component: () => import('./college/class-hour/index.vue'),
  meta: {
    code: '/college/lesson.htm'
  }

}, {
  path: 'mobile-pool-import',
  name: 'mobile-pool-import',
  component: () => import('./mobile/mobile-import/index.vue'),
  meta: {
    code: '/resource/mobilePlatform.htm'
  }
}, {
  path: 'mobile-pool-get',
  name: 'mobile-pool-get',
  component: () => import('./mobile/mobile-get/index.vue'),
  meta: {
    code: '/resource/mobileAddressBook.htm'
  }
}, {
  path: 'hot-topic',
  name: 'hot-topic',
  component: () => import('./hot-topic/index.vue'),
  meta: {
    code: '/award/code.htm'
  }
}, ...booksRouter, ...eBooksRouter];



// WEBPACK FOOTER //
// ./src/views/operate/index.route.js